var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallDesksSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34945 2.91667H10.3036L9.80779 1.16667H1.85987L1.34945 2.91667ZM8.62654 4.08333H3.04112L2.8807 5.25H8.77237L8.62654 4.08333ZM1.15987 9.33333L1.87445 4.08333H0.576536C0.382092 4.08333 0.22887 4.00556 0.11687 3.85C0.00486954 3.69444 -0.0266304 3.52431 0.0223696 3.33958L0.85362 0.422917C0.892508 0.296528 0.960564 0.194444 1.05779 0.116667C1.15501 0.0388888 1.27168 0 1.40779 0H10.2453C10.3814 0 10.4981 0.0388888 10.5953 0.116667C10.6925 0.194444 10.7606 0.296528 10.7995 0.422917L11.6307 3.33958C11.6793 3.52431 11.6478 3.69444 11.5362 3.85C11.4246 4.00556 11.2714 4.08333 11.0765 4.08333H9.7932L10.4932 9.33333H9.32654L8.93279 6.41667H2.72029L2.32654 9.33333H1.15987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDesksSelected);
export default __webpack_public_path__ + "static/media/SmallDesksSelected.42724ac522cd1b4b4bb92f73502dda6d.svg";
export { ForwardRef as ReactComponent };